"use client";

import Link from "next/link";

type BlogPostBreadcrumbsProps = {
  homeLabel: string;
  guideLabel: string;
  guideHref?: string;
  title: string;
};

export function BlogPostBreadcrumbs({
  homeLabel,
  guideLabel,
  guideHref = "/pruvodce",
  title,
}: BlogPostBreadcrumbsProps) {
  return (
    <nav className="mb-6 text-sm text-foreground">
      <ol className="flex flex-wrap items-center gap-3">
        <li>
          <Link href="/">{homeLabel}</Link>
        </li>
        <li className="text-foreground">/</li>
        <li>
          <Link href={guideHref}>{guideLabel}</Link>
        </li>
        <li className="text-foreground">/</li>
        <li className="text-softiq-secondary font-medium line-clamp-1">
          {title}
        </li>
      </ol>
    </nav>
  );
}
